import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { ServicesProvider } from '../ServicesProvider.js';
import { Services } from './Services.js';
import { servicesProviderDomainsDataSchema } from './ServicesProviderDomainsData.js';

class ServicesProviderDomains extends ServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
        this.analyticsBoardUrl = data.analyticsBoardUrl;
        this.support = data.support;
        this.links = data.links;
        this.branding = data.branding;
        this.physicalAddress = data.physicalAddress;
    }
    validateData(data) {
        const result = servicesProviderDomainsDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderDomains.validation', `ServicesProviderDomains data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.DOMAINS,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.DOMAINS, ServicesProviderDomains);

export { ServicesProviderDomains };
//# sourceMappingURL=ServicesProviderDomains.js.map
